import styled from "styled-components";

/* Ocupa el panel de lado a lado (compensa sus 24px de padding). */
export const Road = styled.div`
  position: relative;
  container-type: inline-size;
  align-self: center;
  flex-shrink: 0;
  width: calc(100% + 48px);
  aspect-ratio: 802 / 291;
`;

export const RoadImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;

/* Tamaños en % y cqw para que botones y números escalen junto con la carretera.
   El borde blanco corta el asfalto alrededor de cada botón, como en el diseño. */
export const WeekButton = styled.button`
  position: absolute;
  width: 4%;
  aspect-ratio: 1;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #2F6D92;
  color: #fff;
  font-size: 0.9rem;
  font-size: 2cqw;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 0 0 4px #fff;
  box-shadow: 0 0 0 0.5cqw #fff;
  transform: translate(-50%, -50%);
  cursor: pointer;

  &:hover { background: #245673; }

  &:disabled {
    background: #d9d9d9;
    cursor: default;
  }
`;

export const Car = styled.img`
  position: absolute;
  width: 6.2%;
  transform: translate(-50%, -100%) ${({ $flip }) => ($flip ? "scaleX(-1)" : "")};
  pointer-events: none;
`;
